<template>
  <div>
    <HeaderBacklogComponent @abrirFiltroEmit="mudancaStatusFiltro" />

    <SGPFiltroAvancadoComponent
      :abrirFiltroAvancado="abrirFiltroAvancado"
      filtroPainel
      :comCentroFuncional="ehModuloRecuperacao"
      :comFiltroProvedorNome="podeFiltrarPorProvedor"
      @sgpFormFilterDadosClick="aplicarFiltroPainel"
      @mudancaStatusEmit="mudancaStatusFiltro"
      @limparDadosEmit="limparFiltroPainel"
    />

    <v-tabs-items v-model="tabs" class="painel-produzidos-tabs mt-5">
      <v-tab-item class="pt-5">
        <TotalizadoresComponent
          :listaTarefasMacroprocessos="headerBacklog"
          :selectedBoxId="selectedBoxId"
          @emitBoxClick="recebeBoxClick"
        />

        <SGPLoadingComponent v-if="loadingBacklog" />

        <div v-if="!loadingBacklog" class="mt-5">
          <v-row v-if="mostrarListaDeProcesso" align="center">
            <v-col cols="auto">
              <span class="font-weight-bold">Visualizar por:</span>
            </v-col>

            <v-col>
              <SGPRadioGroupComponent
                v-model="tipoVisualizacao"
                :options="tiposVisualizacao"
                row
              />
            </v-col>
          </v-row>

          <div v-if="tipoVisualizacao === TIPO_VISUALIZACAO_PROCESSO_STATUS">
            <div v-if="ctrlProcessoSelecionadoId != null" class="mt-6">
              <div class="d-flex align-center mb-3">
                <span class="title mr-3">Tarefas do processo</span>
                <SGPLoadingComponent v-if="loadingDetalhesProcesso" />
              </div>

              <v-data-table
                v-if="!loadingDetalhesProcesso && tarefasDetalheLista.length"
                :headers="headersTarefasDetalhe"
                :items="tarefasDetalheLista"
                item-key="ctrl_tarefa_id"
                class="custom_table backlog-processo-tabela elevation-0"
                hide-default-footer
                disable-sort
              >
                <template v-slot:item.tarefa="{ item }">
                  <span class="backlog-tarefa-nome">
                    {{ item.tarefa }}
                  </span>
                </template>

                <template v-slot:item.acoes="{ item }">
                  <SGPFormBotaoComponent
                    fab
                    rounded
                    color="warning"
                    x-small
                    @click.stop="irParaFilaTarefa(item, item)"
                  >
                    <v-icon color="white" small>mdi-eye</v-icon>
                  </SGPFormBotaoComponent>
                </template>

                <!-- Collapse desabilitado — feature removida
                :expanded.sync="expandedTarefas"
                show-expand
                single-expand

                <template v-slot:item.tarefa="{ item }">
                  <span
                    class="cursor-pointer backlog-tarefa-nome"
                    @click.stop="toggleExpandTarefa(item)"
                  >
                    {{ item.tarefa }}
                  </span>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="backlog-expanded-cell text-center">
                    <div class="backlog-pco-nested pa-4">
                      <div v-if="!linhasPcoParaTabela(item).length" class="text--secondary">
                        Nenhuma tarefa encontrada.
                      </div>

                      <template v-else>
                        <SGPPaginacaoComponent
                          v-if="resumoPaginacaoPco(item).total > 0"
                          :paginacao="resumoPaginacaoPco(item)"
                          :exibirTotalRegistros="false"
                          :key="`pco-pag-${item.ctrl_tarefa_id}-${resumoPaginacaoPco(item).current_page}`"
                          @sgpAtualizarPaginacao="(p) => aoMudarPaginaPco(p, item)"
                        >
                          <SGPTabelaComponent
                            customClass="backlog-pco-simple-table"
                            :colunas="headersPcoTarefasDetalhe"
                            :dados="linhasPcoParaTabela(item)"
                            :usuarioPodeEditar="false"
                            :usuarioPodeExcluir="false"
                            :botaoInline="false"
                            :somenteLeitura="true"
                            :filtroText="true"
                          >
                            <template #item.numero_rec_contrato="{ item: linhaPco }">
                              <span>{{ textoRecContrato(linhaPco) }}</span>
                            </template>

                            <template #item.interrompida="{ item: linhaPco }">
                              <v-icon small :color="linhaPco.interrompida ? 'success' : 'grey'">
                                {{ linhaPco.interrompida ? 'mdi-check-circle' : 'mdi-close-circle' }}
                              </v-icon>
                            </template>

                            <template #item.dentro_sla="{ item: linhaPco }">
                              <v-icon small :color="linhaPco.dentro_sla ? 'success' : 'grey'">
                                {{ linhaPco.dentro_sla ? 'mdi-check-circle' : 'mdi-close-circle' }}
                              </v-icon>
                            </template>

                            <template #item.acoes="{ item: linhaPco }">
                              <SGPFormBotaoComponent
                                fab
                                rounded
                                color="warning"
                                x-small
                                @click.stop="irParaFichaTecnicaTarefa(linhaPco, item)"
                              >
                                <v-icon color="white" small>mdi-eye</v-icon>
                              </SGPFormBotaoComponent>
                            </template>
                          </SGPTabelaComponent>
                        </SGPPaginacaoComponent>
                      </template>
                    </div>
                  </td>
                </template>
                -->
              </v-data-table>

              <SGPAlertaComponent
                v-if="
                  !loadingDetalhesProcesso &&
                  ctrlProcessoSelecionadoId != null &&
                  !tarefasDetalheLista.length
                "
                type="info"
              >
                Nenhuma tarefa retornada para este processo.
              </SGPAlertaComponent>
            </div>
          </div>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import TotalizadoresComponent from '../components/TotalizadoresComponent.vue'
import HeaderBacklogComponent from '../components/HeaderBacklogComponent.vue'
import { CTRL_MODULOS } from '@/common/boot/Constantes'
import { usuarioPossuiRole } from '@/common/helpers/usuarioPermissao'

const TIPO_VISUALIZACAO_PROCESSO_STATUS = 'processoTarefaStatus'
const FILTROS_PADRAO = {
  user_tratamento_id: false,
  interrupcoes: false,
  ctrl_processo_id: null,
  periodo: null,
  ctrl_provedor_id: null,
  centro_funcional: null,
  uf_ponta_a: null,
  regional_sigla: null,
  ctrl_regional_id: null,
}
const PAGINACAO_PADRAO = {
  current_page: 1,
  per_page: 20,
  total: 0,
}
const PAGINACAO_LOCAL_PADRAO = {
  current_page: 1,
  per_page: 20,
}

export default {
  name: 'BacklogPage',

  components: {
    TotalizadoresComponent,
    HeaderBacklogComponent,
  },

  data() {
    return {
      TIPO_VISUALIZACAO_PROCESSO_STATUS,
      filtros: { ...FILTROS_PADRAO },
      selectedBoxId: null,
      macroProcessoSelecionado: {},
      processos: [],
      ctrlProcessoSelecionadoId: null,
      // expandedTarefas: [],
      tipoVisualizacao: TIPO_VISUALIZACAO_PROCESSO_STATUS,
      tiposVisualizacao: [
        { label: 'Status', value: TIPO_VISUALIZACAO_PROCESSO_STATUS },
      ],
      mostrarListaDeProcesso: false,
      tabs: 0,
      pcoPaginacaoLocal: {},
      abrirFiltroAvancado: false,
    }
  },

  created() {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('filtroBacklog')
    }
  },

  async mounted() {
    await this.buscarBacklog()
  },

  computed: {
    ...mapGetters('backlog', [
      'listaTarefasBacklog',
      'loadingBacklog',
      'headerBacklog',
      'detalhesProcessoBacklog',
      'loadingDetalhesProcessoBacklog',
    ]),
    ...mapGetters('ctrlModulos', ['moduloAtivo']),
    ...mapGetters('login', ['usuarioLogado']),

    ehModuloRecuperacao() {
      return this.moduloAtivo == CTRL_MODULOS.RECUPERACAO
    },

    usuarioDoFiltro() {
      if (this.usuarioLogado?.id) return this.usuarioLogado

      try {
        return JSON.parse(localStorage.getItem('provedores-usuario')) || {}
      } catch (error) {
        return {}
      }
    },

    podeFiltrarPorProvedor() {
      return usuarioPossuiRole(this.usuarioDoFiltro, ['administrador', 'gestor do sistema'])
    },

    loadingDetalhesProcesso() {
      return this.loadingDetalhesProcessoBacklog
    },

    headersTarefasDetalhe() {
      return [
        { text: 'Tarefa', value: 'tarefa' },
        { text: 'Total', value: 'total_tarefas' },
        { text: 'Não iniciadas', value: 'nao_iniciadas' },
        { text: 'Em atendimento', value: 'em_andamento' },
        { text: 'Interrompidas', value: 'interrompidas' },
        { text: 'Fora SLA', value: 'fora_sla' },
        { text: '% Fora SLA', value: 'percentual_fora_sla' },
        { text: '', value: 'acoes', sortable: false, width: '56', align: 'center' },
      ]
    },

    headersPcoTarefasDetalhe() {
      return [
        { label: 'Número REC / Contrato', key: 'numero_rec_contrato' },
        { label: 'Workflow', key: 'workflow' },
        { label: 'Status', key: 'status' },
        { label: 'Interrompida', key: 'interrompida', headerClass: 'text-center' },
        { label: 'Dentro SLA', key: 'dentro_sla', headerClass: 'text-center' },
        { label: 'Aging', key: 'aging_minutos', headerClass: 'text-right' },
        { label: 'Criado em', key: 'created_at' },
        { label: '', key: 'acoes', headerClass: 'text-center' },
      ]
    },

    tarefasDetalheLista() {
      return Array.isArray(this.detalhesProcessoBacklog?.tarefas)
        ? this.detalhesProcessoBacklog.tarefas
        : []
    },

    filtrosResumo() {
      const payload = {}

      if (this.filtros.user_tratamento_id) {
        payload.user_tratamento_id = true
      }

      if (this.filtros.interrupcoes) {
        payload.interrupcoes = true
      }

      if (this.filtros.periodo) {
        payload.periodo = this.filtros.periodo
      }

      const ctrlProvedorId = this.normalizarNumero(this.filtros.ctrl_provedor_id)
      if (ctrlProvedorId != null) {
        payload.ctrl_provedor_id = ctrlProvedorId
      }

      if (this.ehModuloRecuperacao && this.filtros.centro_funcional) {
        payload.centro_funcional = this.filtros.centro_funcional
      }

      if (this.ehModuloRecuperacao) {
        if (this.filtros.uf_ponta_a) payload.uf_ponta_a = this.filtros.uf_ponta_a
        if (this.filtros.regional_sigla) payload.regional_sigla = this.filtros.regional_sigla
      }

      if (this.moduloAtivo == CTRL_MODULOS.INSTALACAO && this.filtros.ctrl_regional_id) {
        payload.ctrl_regional_id = this.filtros.ctrl_regional_id
      }

      const ctrlProcessoId = this.normalizarNumero(this.filtros.ctrl_processo_id)
      if (ctrlProcessoId != null) {
        payload.ctrl_processo_id = ctrlProcessoId
      }

      return payload
    },
  },

  methods: {
    ...mapActions('backlog', [
      'obterResumoHeaderBacklog',
      'obterDetalhesProcessoBacklog',
    ]),

    normalizarNumero(valor) {
      if (valor == null || valor === '') {
        return null
      }

      const numero = Number(valor)
      return Number.isNaN(numero) ? valor : numero
    },

    obterProcessoId(item) {
      return this.normalizarNumero(
        item?.ctrl_processo_id ?? item?.id ?? item?.ctrl_processo?.id
      )
    },

    obterMacroProcessoId(item) {
      return this.normalizarNumero(
        item?.ctrl_processo_id ?? item?.ctrl_macro_processo_id
      )
    },

    paginacaoLocalPco(ctrlTarefaId) {
      return this.pcoPaginacaoLocal[ctrlTarefaId] || PAGINACAO_LOCAL_PADRAO
    },

    limparEstadoDetalhes() {
      // this.expandedTarefas = []
      this.pcoPaginacaoLocal = {}
    },

    montarPayloadDetalhes(extra = {}) {
      return {
        ctrlProcessoId: this.filtrosResumo.ctrl_processo_id,
        ...this.filtrosResumo,
        ...extra,
      }
    },

    atualizarListaProcessos() {
      const itensLista = this.listaTarefasBacklog?.itens
      const itensHeader = this.headerBacklog?.itens

      this.processos = Array.isArray(itensLista) && itensLista.length
        ? itensLista
        : Array.isArray(itensHeader)
          ? itensHeader
          : []
    },

    linhasPcoDaResposta(tarefaItem) {
      const lista = tarefaItem?.pco_tarefas
      return Array.isArray(lista) ? lista : []
    },

    resumoPaginacaoPco(tarefaItem) {
      if (!tarefaItem) {
        return { ...PAGINACAO_PADRAO }
      }

      if (tarefaItem.paginacao) {
        const pg = tarefaItem.paginacao
        return {
          current_page: pg.current_page || PAGINACAO_PADRAO.current_page,
          per_page: pg.per_page || PAGINACAO_PADRAO.per_page,
          total: pg.total ?? PAGINACAO_PADRAO.total,
        }
      }

      const local = this.paginacaoLocalPco(tarefaItem.ctrl_tarefa_id)
      return {
        current_page: local.current_page,
        per_page: local.per_page,
        total: this.linhasPcoDaResposta(tarefaItem).length,
      }
    },

    formatarLinhaPco(row) {
      return {
        ...row,
        created_at: this.formatarDataPcoTarefa(row?.created_at),
      }
    },

    linhasPcoParaTabela(tarefaItem) {
      if (!tarefaItem) {
        return []
      }

      const todas = this.linhasPcoDaResposta(tarefaItem)
      let pagina = todas

      if (!tarefaItem.paginacao) {
        const { current_page, per_page } = this.paginacaoLocalPco(tarefaItem.ctrl_tarefa_id)
        const inicio = (current_page - 1) * per_page
        pagina = todas.slice(inicio, inicio + per_page)
      }

      return pagina.map((row) => this.formatarLinhaPco(row))
    },

    async aoMudarPaginaPco(paginate, tarefaItem) {
      if (!tarefaItem) {
        return
      }

      const atual = this.resumoPaginacaoPco(tarefaItem)
      const page = paginate.current_page ?? atual.current_page
      const perPage = paginate.per_page ?? atual.per_page

      if (tarefaItem.paginacao) {
        await this.obterDetalhesProcessoBacklog(
          this.montarPayloadDetalhes({
            ctrl_tarefa_id: tarefaItem.ctrl_tarefa_id,
            page,
            per_page: perPage,
          })
        )
        return
      }

      this.$set(this.pcoPaginacaoLocal, tarefaItem.ctrl_tarefa_id, {
        current_page: page,
        per_page: perPage,
      })
    },

    textoRecContrato(linha) {
      const rec = linha?.numero_rec
      const contr = linha?.contrato_guarda_chuva
      const temRec = rec != null && rec !== ''
      const temContr = contr != null && contr !== ''

      if (temRec && temContr) {
        return `${rec} / ${contr}`
      }

      if (temRec) {
        return String(rec)
      }

      if (temContr) {
        return String(contr)
      }

      return '—'
    },

    filterProcesso() {
      this.atualizarListaProcessos()
    },

    async carregarDetalhesProcesso(ctrlProcessoId) {
      const id = this.normalizarNumero(ctrlProcessoId)

      if (id == null) {
        this.ctrlProcessoSelecionadoId = null
        this.pcoPaginacaoLocal = {}
        return
      }

      this.ctrlProcessoSelecionadoId = id
      this.limparEstadoDetalhes()

      await this.obterDetalhesProcessoBacklog(this.montarPayloadDetalhes())
    },

    async buscarBacklog() {
      await this.obterResumoHeaderBacklog(this.filtrosResumo)
      await this.obterDetalhesProcessoBacklog(this.montarPayloadDetalhes())

      this.atualizarListaProcessos()
    },

    async onProcessoRowClick(item) {
      await this.carregarDetalhesProcesso(this.obterProcessoId(item))
    },

    // toggleExpandTarefa(item) {
    //   const tarefa = this.tarefasDetalheLista.find(
    //     ({ ctrl_tarefa_id }) => ctrl_tarefa_id === item.ctrl_tarefa_id
    //   )
    //
    //   if (!tarefa) {
    //     return
    //   }
    //
    //   this.expandedTarefas = this.expandedTarefas.includes(tarefa) ? [] : [tarefa]
    // },

    formatarDataPcoTarefa(valor) {
      if (valor == null || valor === '') {
        return '—'
      }

      const data = moment(valor)
      return data.isValid() ? data.format('DD/MM/YYYY HH:mm') : String(valor)
    },

    irParaFilaTarefa(row, tarefaPai) {
      const ctrlTarefaId = row?.ctrl_tarefa_id ?? tarefaPai?.ctrl_tarefa_id

      if (ctrlTarefaId == null || ctrlTarefaId === '') {
        return
      }

      const filtros = { ...this.filtrosResumo }
      delete filtros.ctrl_processo_id
      const route = this.$router.resolve({
        path: `/workflow/filas-tarefas/${ctrlTarefaId}`,
        query: filtros,
      })
      window.open(route.href, '_blank')
    },

    irParaFichaTecnicaTarefa(tarefaPco) {
      const route = this.$router.resolve({ path: `/workflow/ficha-tecnica-tarefa/${tarefaPco.id}` })
      window.open(route.href, '_blank')
    },

    async atualizarFiltro(campo, valor) {
      this.filtros[campo] = valor
      await this.buscarBacklog()
    },

    mudancaStatusFiltro(val) {
      this.abrirFiltroAvancado = val
    },

    async aplicarFiltroPainel(dados = {}) {
      this.filtros = {
        ...FILTROS_PADRAO,
        ctrl_processo_id: this.filtros.ctrl_processo_id,
        user_tratamento_id: Boolean(dados.user_tratamento_id),
        interrupcoes: Boolean(dados.interrupcoes),
        periodo: this.textoFiltro(dados.periodo),
        centro_funcional: this.textoFiltro(dados.centro_funcional),
        ctrl_provedor_id: this.normalizarNumero(dados.ctrl_provedor_id),
        uf_ponta_a: dados.uf_ponta_a || null,
        regional_sigla: dados.regional_sigla || null,
        ctrl_regional_id: dados.ctrl_regional_id || null,
      }
      this.abrirFiltroAvancado = false
      await this.buscarBacklog()
    },

    textoFiltro(valor) {
      const texto = String(valor ?? '').trim()
      return texto || null
    },

    async limparFiltroPainel() {
      const processoId = this.filtros.ctrl_processo_id
      this.filtros = { ...FILTROS_PADRAO, ctrl_processo_id: processoId }
      await this.buscarBacklog()
    },

    async recebeBoxClick(item) {
      const ctrlProcessoId = this.obterMacroProcessoId(item)

      this.filtros.ctrl_processo_id = ctrlProcessoId
      this.selectedBoxId = ctrlProcessoId
      this.macroProcessoSelecionado = item
      this.mostrarListaDeProcesso = true

      await this.carregarDetalhesProcesso(ctrlProcessoId)
    },
  },

  watch: {
    listaTarefasBacklog() {
      this.atualizarListaProcessos()
    },

    headerBacklog: {
      deep: true,
      handler() {
        this.atualizarListaProcessos()
      },
    },
  },
}
</script>

<style src="@/assets/scss/_backlog.scss" lang="scss" />